import { useState, useCallback, useEffect, useRef } from 'react';
import { cloneDeep } from 'lodash-es';
import { useDispatch } from 'react-redux';
import { searchExcludeAPI } from 'services/searchExcludeAPI.service';

export const useToggleState = (
  selectedCampaigns = [],
  foundedCampaigns = [],
  setSearch,
  setSelectedCampaigns,
  search,
  setIsOpen,
) => {
  const [state, stateSet] = useState(selectedCampaigns);
  const flag = useRef(true);
  const dispatch = useDispatch();
  const restore = useCallback(() => {
    stateSet(selectedCampaigns);
    flag.current = true;
  }, [selectedCampaigns]);

  useEffect(() => {
    stateSet(selectedCampaigns);
  }, [selectedCampaigns]);

  const isActive = useCallback(
    (cm_campaignid) => {
      return state.find((camp) => camp.cm_campaignid === cm_campaignid) ? true : false;
    },
    [state],
  );

  const deleteItem = (cm_campaignid) => {
    let newItems = cloneDeep(state);
    newItems = newItems.filter((camp) => camp.cm_campaignid !== cm_campaignid);
    stateSet(newItems);
    flag.current = false;
  };

  const findItem = (cm_campaignid, foundedCampaigns) => {
    return foundedCampaigns?.concat(state)?.find((camp) => camp?.cm_campaignid === cm_campaignid);
  };

  const addItem = (obj) => {
    let newItems = cloneDeep(state);
    newItems = newItems.concat(obj);
    stateSet(newItems);
    flag.current = false;
  };

  const toggle = useCallback(
    (checked, cm_campaignid) => {
      return isActive(cm_campaignid)
        ? deleteItem(cm_campaignid)
        : addItem(findItem(cm_campaignid, foundedCampaigns));
    },
    [isActive, foundedCampaigns],
  );

  const handleSaveSelectedCampaigns = useCallback(() => {
    setSelectedCampaigns(state);
    setIsOpen(false);
    dispatch(searchExcludeAPI.util.resetApiState());
    setSearch('');
    flag.current = true;
  }, [state]);

  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value || '');
  }, []);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
  }, []);

  const itemsToShow = useCallback(() => {
    if (!search) return state;
    if (search) return foundedCampaigns;
  }, [foundedCampaigns, search]);

  return {
    restore,
    isActive,
    toggle,
    handleSaveSelectedCampaigns,
    handleSearchOnChange,
    handleClearSearchValue,
    itemsToShow,
    flag,
  };
};
